var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isPaymentCardsExist
    ? _c("PaymentOptionsList", {
        attrs: {
          cardFormProcessing: _vm.creatingNewSubscription,
          chosenCardProcessing: _vm.applyingChosenCard,
          cardFormTitle: _vm.cardFormTitle,
          cardsListTitle: _vm.cardsListTitle,
          currentUserId: _vm.currentUserId,
          paymentCards: _vm.paymentCards,
          errorMessage: _vm.errorMessage,
        },
        on: {
          chooseCard: _vm.subscribeWithExistingCard,
          addCard: _vm.subscribeWithNewCard,
        },
      })
    : _c("AddPaymentCardForm", {
        attrs: {
          currentUserId: _vm.currentUserId,
          outerProcessing: _vm.creatingNewSubscription,
          outerErrorMessage: _vm.errorMessage,
          buttonText: "Add Credit Card (Optional)",
        },
        on: { addCard: _vm.subscribeWithNewCard },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }